import React, { useEffect, useState, useCallback, useMemo } from "react"
import { Play, Pause } from "lucide-react"

export default function AudioPlayer() {
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0)
  const [audio, setAudio] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const tracks = useMemo(
    () => ["/audio/The gong bath.mp3", "/audio/Tunning.mp3"],
    []
  )

  const togglePlayPause = useCallback(() => {
    if (audio) {
      if (isPlaying) {
        audio.pause()
      } else {
        audio.play().catch((error) => {
          console.log("Audio playback failed:", error)
        })
      }
      setIsPlaying(!isPlaying)
    }
  }, [audio, isPlaying])

  useEffect(() => {
    const audioElement = new Audio(tracks[currentTrackIndex])
    setAudio(audioElement)
    audioElement.volume = 0.5

    const handleTrackEnd = () => {
      setCurrentTrackIndex((prevIndex) => (prevIndex + 1) % tracks.length)
    }

    audioElement.addEventListener("ended", handleTrackEnd)

    return () => {
      audioElement.removeEventListener("ended", handleTrackEnd)
      audioElement.pause()
      audioElement.src = ""
    }
  }, [currentTrackIndex, tracks])

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={togglePlayPause}
        className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-bold w-16 h-16 rounded-full shadow-lg transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 flex items-center justify-center group overflow-hidden"
        aria-label={isPlaying ? "Pause" : "Play"}
      >
        <div className="relative w-8 h-8">
          <Pause
            className={`w-8 h-8 absolute top-0 left-0 transition-opacity duration-300 ${
              isPlaying ? "opacity-100" : "opacity-0"
            }`}
          />
          <Play
            className={`w-8 h-8 absolute top-0 left-0 transition-opacity duration-300 ${
              isPlaying ? "opacity-0" : "opacity-100"
            }`}
          />
        </div>
        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-full"></div>
      </button>
    </div>
  )
}
